import axios from 'axios'
import APP_CONFIG from '@/config/config'

// 1.使用者進入網站
export const intoUser = async (requestData) => {
	try {
		const res = await axios.post(`${APP_CONFIG.api.baseUri}/into`, requestData)
		return res.data
	} catch (err) {
		console.error(`使用者進入網站 API失敗 `, err.response?.data || err)
		throw err
	}
}

// 2.送出製作影片
export const submitData = async (data) => {
	try {
		const res = await axios.post(`${APP_CONFIG.api.baseUri}/composite`, data)
		return res.data
	} catch (err) {
		console.error(`選色和送出照片 API失敗 `, err.response?.data || err)
		throw err
	}
}

// 3.輪詢製作進度
export const checkResultData = async (token) => {

	try {
		const res = await axios.post(`${APP_CONFIG.api.baseUri}/check`, {token: token})
		return res.data
	} catch (err) {
		console.error(`提交標籤 API失敗 `, err.response?.data || err)
		throw err
	}
}

// 4.點擊分享先檢查好友
export const checkIsFriend = async(data) => {
	try {
		const res = await axios.post(`${APP_CONFIG.api.baseUri}/share`,data)
		return res.data
	} catch (err) {
		console.error(`點擊分享先檢查好友 API失敗 `, err.response?.data || err)
		throw err
	}
}

// 5.兌換核銷
export const submitRedeem= async(redeemData) => {
	try {
		const res = await axios.post(`${APP_CONFIG.api.baseUri}/redeem`,redeemData)
		return res.data
	} catch (err) {
		console.error(`兌換核銷 API失敗 `, err.response?.data || err)
		throw err
	}
}


